import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Admin from '../../store/admin';

import { PropertyGroupTypes } from '@components/admin/PropertyGroupTypes';

export default connect(
    (state: ApplicationState) => ({
        ...Admin.plainActions,
    }),
    Admin.actionCreators,
)(PropertyGroupTypes as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
